import { CircularProgress } from '@mui/material';
import React from 'react';

const Loading = () => <CircularProgress color="inherit" />;

export default Loading;
